import { render, staticRenderFns } from "./CampaignContent.vue?vue&type=template&id=67709106&scoped=true&"
import script from "./CampaignContent.vue?vue&type=script&lang=js&"
export * from "./CampaignContent.vue?vue&type=script&lang=js&"
import style0 from "./CampaignContent.vue?vue&type=style&index=0&id=67709106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67709106",
  null
  
)

export default component.exports